import React from "react";

import WhatHappensNext from "./WhatHappensNext";

import { classNameGenerator } from "@/utils";

import styles from "./HowItWorksSection.module.scss";
import { useAppSelector } from "@/hooks";

interface HowItWorksSectionProps {
  children: React.ReactNode;
}

const HowItWorksSection: React.FC<HowItWorksSectionProps> = ({ children }) => {
  const cls = classNameGenerator(styles);
  const { data } = useAppSelector((state) => state.bootCamp);

  if(!data?.bookConsultation)
    return <></>
    
  return (
    <section className={cls("howItWorksSection")}>
      <div className={cls("container")}>
        <WhatHappensNext />
        <div className={cls("formWrapper")}>{children}</div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
